module.exports = __webpack_public_path__ + "img/ic-work.fe949bf6.svg";